import { render, staticRenderFns } from "./DoctorMain.vue?vue&type=template&id=0463f886&"
import script from "./DoctorMain.vue?vue&type=script&lang=js&"
export * from "./DoctorMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports